/** Parcours d'apprentissage et points de connaissance. */
import type { KnowledgePointProgressView, LearningMode, LearningNodeProgress } from '@unity-learning/shared';
import { apiGet, apiPost } from './client';

/** Crée les lignes de progression manquantes ; idempotent. */
export function initializeLearningPath(userId: string): Promise<void> {
  return apiPost<void>(`/api/learning-path/initialize/${encodeURIComponent(userId)}`);
}

export function getLearningPathProgress(userId: string): Promise<LearningNodeProgress[]> {
  return apiGet<LearningNodeProgress[]>(`/api/learning-path/progress/${encodeURIComponent(userId)}`).then(
    (rows) => rows ?? []
  );
}

/** Nœud du curriculum avec ses compteurs de points de connaissance pour l'utilisateur. */
export interface KnowledgeNodeSummary {
  id: string;
  title: string;
  kp_count: number;
  completed_count: number;
  [column: string]: unknown;
}

export function getKnowledgeNodes(userId: string, learningMode: LearningMode): Promise<KnowledgeNodeSummary[]> {
  return apiGet<KnowledgeNodeSummary[]>('/api/knowledge/nodes', { query: { userId, learning_mode: learningMode } });
}

/**
 * Points de connaissance d'un nœud avec la progression de l'utilisateur.
 * Le type précis (colonnes jointes) est celui du composant appelant.
 */
export function getNodeKnowledgePoints<T>(nodeId: string, userId: string): Promise<T[]> {
  return apiGet<T[]>(`/api/knowledge/nodes/${encodeURIComponent(nodeId)}/points`, { query: { userId } });
}

/**
 * Où en est l'étudiant sur UN point de connaissance : repère, compteur et bouton « Connaissance suivante »
 * de la page d'exercice. Rejette avec une `ApiError` 404 si le point n'existe plus dans le parcours.
 */
export function getKnowledgePointProgress(userId: string, kpId: string): Promise<KnowledgePointProgressView> {
  return apiGet<KnowledgePointProgressView>(`/api/knowledge/points/${encodeURIComponent(kpId)}/progress`, { query: { userId } });
}
